<template>
	<div class="card">
		<div class="card-body">
			<ListMenu
				:id="`${id}-menu`"
				:item="item"
				:eventBus="eventBus"
				:mobile="true"
				class="card-menu"
			/>
			<div class="card-details">
				<div class="card-title">{{ item.name }}</div>
				<div class="card-subtitle">{{ item['length'] }}</div>
				<div class="card-text">
					Purchase Date: {{ $moment(item.enrollment.enrolled_at).format('MM/DD/YYYY') }}
					<br />
					Status: {{ item.enrollment.completion_status_label }}
				</div>
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import ListCardMixin from "mixins/ListCard";
import ListMenu from "./ListMenu";
export default {
	mixins: [ListCardMixin],
	components: { ListMenu },
};
</script>